/** @file Sets editor view settings (grid mode, tile size, iso angle, snap, footprint); omitted fields stay. */
import { z } from 'zod';
import { skeletonParts } from '@pose2d/format/doc/schemaParts/skeleton';
import { defineCommand } from '../defineCommand';

export const command = defineCommand({
  name: 'project.setView',
  description: 'Set editor-only view settings: grid { mode off|square|iso, tileW, tileH, isoAngle, snap, footprint }; omitted fields keep their value.',
  input: z.object({ grid: skeletonParts.view.shape.grid.partial().strict() }).strict(),
  apply(draft, input, ctx) {
    Object.assign(draft.view.grid, input.grid);
    draft.meta.updatedAt = ctx.now;
  },
});
